import React, { Component } from 'react';
import $ from 'jquery';
import Vas from '../../../Vas';
import '../../../css/CustomerContractDetails.css';
import { TextField,TabControl } from 'component-lib';
import { DateTimeHelper,CurrencyConverter } from 'utils-lib';
import { RequestAjaxClass, ContractDetailsModel} from 'models-lib';
var moment = require('moment');
moment().format();
class CustomerContractDetails extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {};
        this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error)},null);
    
        this.ContractDetailsModel = new ContractDetailsModel([this],null, this.Request);
    }

    componentWillMount(){
        $("#LoadingIcon").removeClass().addClass('loaderSmall');
        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setAuth(true);
        this.Request.setErrorHandler((data)=>{
          $("#LoadingIcon").removeClass().addClass('hide');
        });

        this.LogoClick();

        this.FontSizeClick();
    }

    componentDidMount(){
        this.ContractDetailsModel.GetContractDetailsByContractId(this.props.Id);

        this.LogoClick();

        this.FontSizeClick();
    }

    Update(observer)
    {
      let me = this;
        this.setState({},()=>{
          if(observer === "ContractDetails"){
            
                me.refs.ContractStart.setState({ Value: me.ContractDetailsModel.Contract.DateFrom });
                let from = DateTimeHelper.StringToDate( me.ContractDetailsModel.Contract.DateFrom,false,localStorage.getItem('vas_language'));
                let to = DateTimeHelper.StringToDate( me.ContractDetailsModel.Contract.DateTo,false,localStorage.getItem('vas_language'));

                me.refs.ContractEnd.setState({ Value: to.isBefore(from) ? "" : me.ContractDetailsModel.Contract.DateTo });
                
                //Hier die Bezeichnung des Status anpassen
                //Neu an dieser Stelle Status Gekündigt (Beachte Darstellung Umpaut ü)
                switch(me.ContractDetailsModel.Contract.StatusId){
                  case 2:
                    me.refs.State.setState({ Value:Vas.Resources.Labels["Canceled"] });
                  break;

                  case 10:
                    me.refs.State.setState({ Value:Vas.Resources.Labels["PendingApproval"] });
                  break;

                  default:
                    me.refs.State.setState({ Value:me.ContractDetailsModel.Contract.Status }); 
                  break;
                }
                
                me.refs.ContractNumber.setState({ Value: me.ContractDetailsModel.Contract.ContractNumber });
                me.refs.NameOfBank.setState({ Value: me.ContractDetailsModel.PaymentOptionCustomer ? me.ContractDetailsModel.PaymentOptionCustomer.BankName : "" });
                me.refs.Iban.setState({ Value: me.ContractDetailsModel.PaymentOptionCustomer ? me.ContractDetailsModel.PaymentOptionCustomer.Iban: "" });
                me.refs.Bic.setState({ Value: me.ContractDetailsModel.PaymentOptionCustomer ? me.ContractDetailsModel.PaymentOptionCustomer.Bic: "" });
                me.refs.Depositor.setState({ Value: me.ContractDetailsModel.PaymentOptionCustomer ? me.ContractDetailsModel.PaymentOptionCustomer.AccountOwner : "" });
                me.refs.From.setState({ Value: me.ContractDetailsModel.ContractConnection.From });
                me.refs.To.setState({ Value: me.ContractDetailsModel.ContractConnection.To });
                me.refs.Via.setState({ Value: me.ContractDetailsModel.ContractConnection.Via });
                me.refs.ProductPrice.setState({ Value: CurrencyConverter.Cast( me.ContractDetailsModel.ContractPrice.Price, localStorage.getItem("vas_language") ,2) });
                me.refs.PriceLevel.setState({ Value: me.ContractDetailsModel.ContractPrice.PriceLevel });
                me.refs.Share1.setState({ Value:me.ContractDetailsModel.Share1 });
                me.refs.Share2.setState({ Value:me.ContractDetailsModel.Share2 });
  
            
            $("#LoadingIcon").removeClass().addClass('hide');
          }
        });

        this.LogoClick();

        this.FontSizeClick();
    }

    LogoClick(){
      var kontrastNumber = localStorage.getItem('Kontrast');

      if(kontrastNumber == "true"){

          $('.pagingTable tbody td, .pagingTableWithoutBorder tbody td').attr('style', 'border-bottom: 1px solid #1d5c87;');

          $('.pagingTable tbody tr, .pagingTableWithoutBorder tbody tr').mouseenter(function() {
              $(this).attr('style', 'background-color: #1d5c87 !important;');
          }).mouseleave(function() {
                $(this).attr('style', 'background-color: #1d5c87 !important;');
          });
      }
    }

    FontSizeClick(){
      var schriftgröße = localStorage.getItem('Schriftgröße');
      let role = localStorage.getItem("vas_role");

      //Schriftgröße bei Klick in 2er Schritten erhöhen

        if(schriftgröße != null){
            
              switch(schriftgröße){
                case "0":

                      if (role === '3'){
                          $('.tablinks').removeClass('Schriftgröße_17').addClass('Schriftgröße_18').addClass('visible');
                          $('.active').removeClass('Schriftgröße_17').addClass('Schriftgröße_18');

                          $('#undefinedLabel').removeClass('Schriftgröße_18').addClass('Schriftgröße_19');
                        $('.textfieldDisabled').removeClass('Schriftgröße_18').addClass('Schriftgröße_19');

                        $('#titleMenuContractDetails').attr('style', 'display: none');
                      }
                break;
                case "1":

                      if (role === '3'){
                        $('.tablinks').removeClass('Schriftgröße_18').addClass('Schriftgröße_13').addClass('visible');
                        $('.active').removeClass('Schriftgröße_18').addClass('Schriftgröße_13');

                        $('#undefinedLabel').removeClass('Schriftgröße_19').addClass('Schriftgröße_14');
                        $('.textfieldDisabled').removeClass('Schriftgröße_19').addClass('Schriftgröße_14');

                        $('#titleMenuContractDetails').attr('style', 'display: none');
                      }

                break;
                case "2":

                      if (role === '3'){
                        $('.tablinks').removeClass('Schriftgröße_13').addClass('Schriftgröße_14').addClass('visible');
                        $('.active').removeClass('Schriftgröße_13').addClass('Schriftgröße_14');

                        $('#undefinedLabel').removeClass('Schriftgröße_14').addClass('Schriftgröße_15');
                        $('.textfieldDisabled').removeClass('Schriftgröße_14').addClass('Schriftgröße_15');

                        $('#titleMenuContractDetails').attr('style', 'display: none');
                      }

                break;
                case "3":
                      if (role === '3'){
                        $('.tablinks').removeClass('Schriftgröße_14').addClass('Schriftgröße_15').addClass('visible');
                        $('.active').removeClass('Schriftgröße_14').addClass('Schriftgröße_15');

                        $('#undefinedLabel').removeClass('Schriftgröße_15').addClass('Schriftgröße_16');
                        $('.textfieldDisabled').removeClass('Schriftgröße_15').addClass('Schriftgröße_16');

                        $('#titleMenuContractDetails').attr('style', 'display: none');
                      }
                break;
                case "4":

                      if (role === '3'){
                        $('.tablinks').removeClass('Schriftgröße_15').addClass('Schriftgröße_16').addClass('visible');
                        $('.active').removeClass('Schriftgröße_15').addClass('Schriftgröße_16');

                        $('#undefinedLabel').removeClass('Schriftgröße_16').addClass('Schriftgröße_17');
                        $('.textfieldDisabled').removeClass('Schriftgröße_16').addClass('Schriftgröße_17');

                        $('#titleMenuContractDetails').attr('style', 'display: none');
                      }
                break;
                case "5":                

                      if (role === '3'){
                        $('.tablinks').removeClass('Schriftgröße_16').addClass('Schriftgröße_17').addClass('visible');
                        $('.active').removeClass('Schriftgröße_16').addClass('Schriftgröße_17');

                        $('#undefinedLabel').removeClass('Schriftgröße_17').addClass('Schriftgröße_18');
                        $('.textfieldDisabled').removeClass('Schriftgröße_17').addClass('Schriftgröße_18');

                        $('#titleMenuContractDetails').attr('style', 'display: none');
                      }
                break;
              }
        }
  }

    render()
    {         
      
        return (
          <TabControl 
            Id={"ContractDetails"}
            Content={[
          { Title:Vas.Resources.Labels["ContractData"],Content:<table>
            <tbody>
              <tr>
                <td><TextField
                  ref={"ContractNumber"}
                  AppURL={Vas.ApplicationUrl}
                  Label={Vas.Resources.Labels["ContractNumber"]}
                  Editable={false} /></td>
                <td><TextField
                  ref={"ProductPrice"}
                  AppURL={Vas.ApplicationUrl}
                  Label={Vas.Resources.Labels["ProductPrice"]}
                  Editable={false} /></td>

              </tr>
              <tr>
                <td><TextField
                  ref={"PriceLevel"}
                  AppURL={Vas.ApplicationUrl}
                  Label={Vas.Resources.Labels["PriceLevel"]}
                  Editable={false} /></td>
                <td><TextField
                  ref={"State"}
                  AppURL={Vas.ApplicationUrl}
                  Label={Vas.Resources.Labels["State"]}
                  Editable={false} /> </td>
              </tr>
              <tr>
                <td><TextField
                  ref={"ContractStart"}
                  AppURL={Vas.ApplicationUrl}
                  Label={Vas.Resources.Labels["ContractStart"]}
                  Editable={false} /></td>
                <td><TextField
                  ref={"ContractEnd"}
                  AppURL={Vas.ApplicationUrl}
                  Label={Vas.Resources.Labels["ContractEnd"]}
                  Editable={false} /></td>
              </tr>
              <tr>
                <td><TextField
                  ref={"Share1"}
                  AppURL={Vas.ApplicationUrl}
                  Label={Vas.Resources.Labels["Share1"]}
                  Editable={false} /></td>
                <td><TextField
                  ref={"Share2"}
                  AppURL={Vas.ApplicationUrl}
                  Label={Vas.Resources.Labels["Share2"]}
                  Editable={false} /></td>
              </tr>
            </tbody>
          </table> },
          { Title:Vas.Resources.Labels["ConnectionData"],Content:<table><tbody> <tr>
            <td><TextField
              ref={"From"}
              AppURL={Vas.ApplicationUrl}
              Label={Vas.Resources.Labels["From"]}
              Editable={false} /></td>
            <td><TextField
              ref={"To"}
              AppURL={Vas.ApplicationUrl}
              Label={Vas.Resources.Labels["To"]}
              Editable={false} /> </td>
          </tr>
            <tr>
              <td><TextField
                ref={"Via"}
                AppURL={Vas.ApplicationUrl}
                Label={Vas.Resources.Labels["Via"]}
                Editable={false} /></td>
            </tr>
          </tbody>
          </table> },
          { Title:Vas.Resources.Labels["DefaultMethodOfPayment"],Content:<table><tbody><tr>
            <td><TextField
              ref={"Depositor"}
              AppURL={Vas.ApplicationUrl}
              Label={Vas.Resources.Labels["Depositor"]}
              Editable={false} /></td>
            <td><TextField
              ref={"NameOfBank"}
              AppURL={Vas.ApplicationUrl}
              Label={Vas.Resources.Labels["NameOfBank"]}
              Editable={false} /></td>

          </tr>
            <tr>
              <td><TextField
                ref={"Iban"}
                AppURL={Vas.ApplicationUrl}
                Label={Vas.Resources.Labels["Iban"]}
                Editable={false} /> </td>
              <td><TextField
                ref={"Bic"}
                AppURL={Vas.ApplicationUrl}
                Label={Vas.Resources.Labels["Bic"]}
                Editable={false} /> </td>
            </tr>
          </tbody>
          </table> }
            ]} />
        );
    }
}
export default CustomerContractDetails;
